import { useState } from "react";

// Invite an additional administrator to an existing company.
function AddAdminModal({ company, onAddClicked, onCancelClicked }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    const trimmed = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Enter a valid email");
      return;
    }
    setError("");
    onAddClicked({ identifier: company.identifier, email: trimmed });
  };

  return (
    <div
      onClick={onCancelClicked}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[448px] bg-white rounded-[6px] p-[18px] flex flex-col"
      >
        <p className="text-[16px] font-OpenSansSemiBold text-titleColor mb-1">ADD ADMINISTRATOR</p>
        <p className="text-[12px] font-OpenSansMedium text-subTitleColor mb-5">
          Invite an administrator to <b>{company?.name}</b>
        </p>

        <div className="flex flex-col gap-4">
          <div className="w-full">
            <p className="text-[12px] font-OpenSansSemiBold text-titleColor mb-2">Administrator Email</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px]">
              <input
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-OpenSansMedium"
                placeholder="admin@company.com"
              />
            </div>
          </div>

          {error && <p className="text-[11px] font-OpenSansMedium text-red-500">{error}</p>}

          <div className="w-full mt-2">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={onCancelClicked}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
              >
                CANCEL
              </div>
              <div
                onClick={submit}
                className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
              >
                INVITE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAdminModal;
